import app from '../app.first';

app.DisabilityAndDisorderQuestion = class extends app.Component {
    onReady () {
        this.radioButtonYes = this.$el.find('#pd_have_disabilities-yes');
        this.radioButtonNo  = this.$el.find('#pd_have_disabilities-no');

        this.fieldSocialGrantSpecific = this.$el.find('#pd_disabilities_and_disorders');
        this.fieldContainer    = this.$el.find('#disability-disorders-field');

        this.radioButtonYes.on('click', (evt) => {
            this.fieldSocialGrantSpecific.prop('required', true);
            this.fieldSocialGrantSpecific.prop('style', 'display: block;');
            this.fieldContainer.show();
        });

        this.radioButtonNo.on('click', (evt) => {
            this.fieldSocialGrantSpecific.prop('required', false);
            this.fieldSocialGrantSpecific.prop('style', 'display: none;');
            this.fieldSocialGrantSpecific.val('');
            this.fieldContainer.hide();
        });
	}
}
